<template>
  <!-- <div class="event-lists events-participating d-flex flex-wrap justify-content-between"> -->
  <!-- Modal -->
  <div
    class="modal fade form-wrapper"
    id="join-wishlist-modal"
    tabindex="-1"
    role="dialog"
    v-if="showModal"
    @close="closeJoinByIdModal"
    data-backdrop="static"
    data-keyboard="false"
    aria-labelledby="formModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content form-content">
        <div class="modal-body">
          <img
            class="close"
            src="../../public/assets/images/close.svg"
            data-dismiss="modal"
            aria-label="Close"
            @click="closeJoinByIdModal"
          />
          <div class="payment-form">
            <form class="wishlistJoinForm" id="joinWishlist" @submit="joinWishlistById">
              
              <div class="form-group">
                <label for="code">Join by unique code</label>

                <div class="event-count">
                  <input
                    type="text"
                    class="form-control"
                    id="uniqueCode"
                    name="unique-code"
                    v-model="uniqueCode"
                    ref="uniqueCode"
                    placeholder="Enter your unique code to join!"
                    v-validate="'uniqueCodeFormat|alpha_num'"
                    v-bind:class="{ 'is-invalid': errors.has('unique-code')}"
                  />
                  <span class="invalid-feedback">{{ errors.first('unique-code') }}</span>
                </div>
              </div>
              <div
                class="alert alert-danger alert-dismissible"
                role="alert"
                v-if="showAlertMessage"
              >
                {{apiErrorMessage}}
                <img
                  class="close"
                  src="assets/images/close.svg"
                  data-dismiss="alert"
                  aria-label="close"
                  @click="showAlertMessage=!showAlertMessage"
                />
              </div>

              <div
                class="alert alert-success alert-dismissible"
                role="alert"
                v-if="showSuccessAlertMessage"
              >
                {{apiSuccessMessage}}
                <img
                  class="close"
                  src="assets/images/close.svg"
                  data-dismiss="alert"
                  aria-label="close"
                  @click="showSuccessAlertMessage=!showSuccessAlertMessage"
                />
              </div>
              <button type="submit" class="btn btn-primary" :disabled="disabled == true">Join</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal end -->
  <!-- </div> -->
</template>

<script>
import {
  JOIN_WISHLIST_BY_UNIQUECODE,
  SET_JOINED_WISHLIST_ID
} from "../store/wishlist/action.type";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      uniqueCode: "",
      showAlertMessage: false,
      showSuccessAlertMessage: false,
      apiSuccessMessage: "",
      apiErrorMessage: "",
      closeModal: false,
      disabled: true
    };
  },
  props: {
    show: Boolean
  },
  computed: {
    showModal() {
      return this.show === true
        ? $("#join-wishlist-modal").modal("show")
        : $("#join-wishlist-modal").modal("hide");
    },

    ...mapGetters(["getJoinedWishlistId"])
  },
  methods: {
    joinWishlistById(e) {
      e.preventDefault();
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.$store
            .dispatch(JOIN_WISHLIST_BY_UNIQUECODE, this.uniqueCode)
            .then(response => {
              if (response.status != 200) {
                this.apiErrorMessage = response.data.message;
                this.showAlertMessage = true;
              } else {
                this.apiSuccessMessage = response.data.message;
                this.showSuccessAlertMessage = true;
                this.closeJoinByIdModal();
                if (this.closeModal)
                  setTimeout(
                    () =>
                      this.$router.push({
                        path: "/wishlist/" + this.getJoinedWishlistId
                      }),
                    500
                  );
              }
            })
            .catch(error => {
              this.apiErrorMessage = error.response.data.message;
              this.showAlertMessage = true;
            });
        }
      });
    },

    closeJoinByIdModal() {
      this.closeModal = true;
      this.uniqueCode = "";
      this.$validator.reset();
      this.apiErrorMessage = '';
      this.showAlertMessage = false;
      this.$emit("closeModal");
    }
  },
  watch: {
    uniqueCode(data) {
      if (data) {
        var self = this;
        if (self.uniqueCode.length == 6) {
          self.disabled = false;
        } else self.disabled = true;
      }
    }
  },
  created() {
    this.$validator.extend("uniqueCodeFormat", {
      getMessage: () => "Unique Code must contain exact 6 characters",
      validate: value => value.match(/^[a-zA-Z0-9]{6}$/) !== null
    });
  }
};
</script>

<style>
</style>